import React from 'react';
import type { FmProductFooterDescriptor } from './FmProductPage.types';
import './FmProductFooter.css';

export const FmProductFooter: React.FC<{ footer: FmProductFooterDescriptor }> = ({ footer }) => (
  <footer className="fm-product-footer" data-testid="product-footer">
    <div className="fm-product-footer__inner">
      <div className="fm-product-footer__brand">
        <strong>{footer.brandLabel}</strong>
        <p>{footer.description}</p>
      </div>
      <nav className="fm-product-footer__links" aria-label={footer.legalAriaLabel}>
        <span>{footer.termsLabel}</span>
        <span>{footer.privacyLabel}</span>
        <a href={`mailto:${footer.contactEmail}`}>{footer.contactLabel}</a>
        <button type="button" onClick={footer.onBuyer}>
          {footer.buyerLabel}
        </button>
      </nav>
      <small>
        © {new Date().getFullYear()} {footer.brandLabel}. {footer.allRightsReserved}
      </small>
    </div>
  </footer>
);
